const __WEBPACK_NAMESPACE_OBJECT__ = require("redux-form-material-ui");